export default {"src":"/_next/static/media/feed-the-obesession-animation.692c0958.svg","height":482,"width":1453,"blurWidth":0,"blurHeight":0};